




















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import {
    renderComponents,
    renderSufix
} from "@/components/posts/RenderPostTypeRegister";

import { RenderChannelModel, RenderPostModel, RenderPostStatistic } from "@/services/render/types";
import { RenderEventBus } from "@/render-event-bus";
import { Guid } from "guid-typescript";
import { setNextItem, UpdateDuration } from "../posts/types";
import { PostTypeEnum } from "@/services/posts/types";
import { Getter } from "vuex-class";

@Component({
    components: {
        ...renderComponents
    },
    filters: {
        render(value: string) {
            return value.concat(renderSufix);
        }
    }
})
export default class ShiftRender extends Vue {
    @Prop() private shiftRenderModel!: RenderChannelModel;
    @Prop() private dateTime!: Date;
    @Prop({ default: true }) private preview!: boolean;
    @Getter("preview/getPreviewControlsStatus") previewControlStatus!: boolean;

    currentItemId = "" as string;
    currentOriginalPostId = "" as string;
    currentItemType = "" as string;
    index = 0 as number;
    renderingModel = {} as RenderChannelModel;
    posts: RenderPostModel[] = [];
    transitionStyleId = Guid.create();
    pauseShift = false; // will break the shifting and be reset back to false to be ready for the next pause
    pauseMode = false; // flag thru which we control the play button and the indicators
    showOnlyInfo = false;
    slideTimeRemainingInterval = 0;
    slideTimeRemainingTimer = 0;
    slideTimeRemainingNumber = 0;

    activeInteger = 1;
    calculateActive(itemId: string) {
        return (this.currentItemId === itemId) ? this.activeInteger : 0;
    }

    @Watch("shiftRenderModel") t() {
        if (this.posts.length === 0 && this.shiftRenderModel.renderPosts !== undefined) {
            this.index = 0;
            this.updateModel();
            this.showItem();
        }

        this.calculateControlsVisibility();
    }

    // computed
    get dynamicStyle() {
        return {
            "pointer-events": "none",
            height: `${this.shiftRenderModel.height}px`,
            width: `${this.shiftRenderModel.width}px`
        };
    }

    get progressText() {
        return `${this.index + 1}/${this.renderingModel.renderPosts.length}`;
    }

    get counterIndicatorStyle() {
        return this.renderingModel.counterStyle ? this.renderingModel.counterStyle.counterIndicator : "";
    }

    get durationIndicatorInnerStyle() {
        return this.renderingModel.durationStyle ? this.renderingModel.durationStyle.durationIndicatorInner : "";
    }

    get durationIndicatorOuterStyle() {
        return this.renderingModel.durationStyle ? this.renderingModel.durationStyle.durationIndicatorOuter : "";
    }

    // lifecycle hooks
    created() {
        if (this.shiftRenderModel.renderPosts.length > 0) {
            this.updateModel();
            this.showItem();
            this.setTransitionStyles();
        }

        this.calculateControlsVisibility();
    }

    destroyed() {
        const styles = document.head.getElementsByClassName("transitionStyles-" + this.transitionStyleId);
        if (styles.length > 0) styles[0].remove();
    }

    // functions
    calculateControlsVisibility() {
        this.showOnlyInfo = this.posts.length === 1;
    }

    previous() {
        this.index--;
        if (this.index < 0) {
            this.index = this.posts.length - 1;
        }
        this.showItem();
        RenderEventBus.$emit("reset-info");
    }

    pause() {
        this.pauseShift = true;
        this.pauseMode = true;
        if (this.renderingModel.durationIndicator) {
            const durationIndicator = this.$refs.durationInner as HTMLDivElement;
            if (durationIndicator) {
                durationIndicator.style.transition = "none 0s linear";
                durationIndicator.style.width = "0px";
            }
        }
        clearTimeout(this.slideTimeRemainingTimer);
        clearInterval(this.slideTimeRemainingInterval);
    }

    play() {
        this.pauseShift = false;
        this.pauseMode = false;
        this.showItem();
        RenderEventBus.$emit("reset-info");
    }

    next() {
        this.index++;
        if (this.index >= this.posts.length) {
            this.index = 0;
        }
        this.showItem();
        RenderEventBus.$emit("reset-info");
    }

    info() {
        this.pause();
        RenderEventBus.$emit("show-info", this.currentOriginalPostId);
    }

    setNextItem(data: setNextItem) {
        if (this.pauseShift) {
            this.pauseShift = false;
            return;
        };
        if (this.pauseMode) return;

        if (this.currentItemId !== data.id) return;

        this.setIndexIfUpdated();
        this.setItemIfUpdated();

        if (data !== undefined && data.error === true) {
            for (let i = this.posts.length - 1; i >= 0; --i) {
                if (this.posts[i].id === data.id) {
                    this.posts.splice(i, 1);
                }
            }
        } else {
            const post = this.posts[this.index];
            RenderEventBus.$emit("insert-post-statistic", {
                postId: post.id,
                postType: post.postType,
                duration: post.postType === "Video" ? Math.floor(data.duration) : (post.properties as any).showTime
            } as RenderPostStatistic);

            this.index++;
        }
        this.currentItemId = "";
        this.currentOriginalPostId = "";
        this.currentItemType = "";
        if (this.index >= this.posts.length) {
            this.index = 0;
        }
        this.showItem();
    }

    showItem() {
        if (this.posts.length > 0) {
            this.currentItemId = this.posts[this.index].id;
            this.currentOriginalPostId = this.posts[this.index].originalId;
            this.currentItemType = this.posts[this.index].postType;

            // Video triggers the progress bar and postCountTimer itself with video length as data.
            if (this.posts[this.index].postType !== PostTypeEnum.video) {
                this.triggerDurationIndicator();
                this.triggerPostCountTimer();
            }
        } else {
            this.currentItemId = "";
            this.currentOriginalPostId = "";
            this.currentItemType = "";
        }
        this.activeInteger++;
    }

    updateModel() {
        this.renderingModel = this.shiftRenderModel;
        if (this.shiftRenderModel.renderPosts !== undefined) {
            this.posts = this.shiftRenderModel.renderPosts.slice();
        } else {
            this.posts = [];
        }
    }

    setIndexIfUpdated() {
        if (this.renderingModel.renderPosts.length !== this.shiftRenderModel.renderPosts.length) {
            this.index -= (this.renderingModel.renderPosts.length - this.shiftRenderModel.renderPosts.length);
            if (this.index < 0) this.index = 0;
            this.updateModel();
        }
    }

    setItemIfUpdated() {
        if (JSON.stringify(this.renderingModel) !== JSON.stringify(this.shiftRenderModel)) {
            this.updateModel();
            this.setTransitionStyles();
        }
    }

    triggerPostCountTimer(length: any = null) {
        clearTimeout(this.slideTimeRemainingTimer);
        clearInterval(this.slideTimeRemainingInterval);

        const showTime = Math.floor(length) || (this.posts[this.index] as any).properties.showTime;
        this.slideTimeRemainingNumber = showTime;
        if (this.pauseMode) return;

        this.slideTimeRemainingInterval = setInterval(() => {
            this.slideTimeRemainingNumber--;
        }, 1000);

        this.slideTimeRemainingTimer = setTimeout(() => {
            clearInterval(this.slideTimeRemainingInterval);
        }, showTime * 1000);
    }

    triggerDurationIndicator(data: any = null) {
        if (this.pauseMode) return;
        if (this.renderingModel && this.renderingModel.durationIndicator) {
            this.$nextTick(() => {
                const durationIndicator = this.$refs.durationInner as HTMLDivElement;
                if (durationIndicator) {
                    const post: any = this.posts[this.index];
                    durationIndicator.style.transition = "none 0s linear";
                    durationIndicator.style.width = "0px";

                    // The following line forces the browser to do a reflow (also sometimes called layout thrashing)
                    // A reflow makes the browser recalculate the layout and styling.
                    // This enables us to first set the width to 0px, and then to 100% after.
                    // Usually javascript will read top-down before applying the styles, so if we don't reflow, we would effectively be setting the
                    // width to 100% over and over. This makes it so the browser sets it to 0px, reflows, then 100%, which allows us to actually animate.
                    /* eslint-disable no-void */
                    void (durationIndicator.offsetHeight);

                    const time = data || post.properties.showTime;
                    durationIndicator.style.transition = `width ${time}s linear`;
                    durationIndicator.style.width = "100%";
                }
            });
        }
    }

    updateDuration(model: UpdateDuration) {
        const post = this.posts.find((p) => p.id === model.id);
        if (post) {
            (post.properties as any).showTime = model.duration;
        }
        this.triggerPostCountTimer();
    }

    setTransitionStyles() {
        /*
        Since IE11 doesn't support CSS variables, we have to manually support
        variables by injecting the CSS directly into head.

        This also scopes it to a GUID container to support multiple different shift renders.
        */
        const duration = this.renderingModel.transitionTime / 1000 + "s";
        const channelWidth = `${this.shiftRenderModel.width}px`;
        const channelWidthNegative = `-${this.shiftRenderModel.width}px`;
        const channelHeight = `${this.shiftRenderModel.height}px`;
        const channelHeightNegative = `-${this.shiftRenderModel.height}px`;

        const styleText = `
            .container-${this.transitionStyleId} .fade-enter-active {
                transition: opacity ${duration};
            }
            .container-${this.transitionStyleId} .fade-leave-active {
                transition: opacity ${duration};
            }
            .container-${this.transitionStyleId} .fade-enter,
            .container-${this.transitionStyleId} .fade-leave-to {
                opacity: 0;
            }
            .container-${this.transitionStyleId} .tickerLeft-enter-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerLeft-leave-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerLeft-enter {
                transform: translateX(${channelWidth});
            }
            .container-${this.transitionStyleId} .tickerLeft-leave-to {
                transform: translateX(${channelWidthNegative});
            }
            .container-${this.transitionStyleId} .tickerRight-enter-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerRight-leave-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerRight-enter {
                transform: translateX(${channelWidthNegative});
            }
            .container-${this.transitionStyleId} .tickerRight-leave-to {
                transform: translateX(${channelWidth});
            }
            .container-${this.transitionStyleId} .tickerDown-enter-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerDown-leave-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerDown-enter {
                transform: translateY(${channelHeight});
            }
            .container-${this.transitionStyleId} .tickerDown-leave-to {
                transform: translateY(${channelHeightNegative});
            }
            .container-${this.transitionStyleId} .tickerUp-enter-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerUp-leave-active {
                transition: all ${duration} ease;
            }
            .container-${this.transitionStyleId} .tickerUp-enter {
                transform: translateY(${channelHeightNegative});
            }
            .container-${this.transitionStyleId} .tickerUp-leave-to {
                transform: translateY(${channelHeight});
            }`;

        const styleTag = document.head.getElementsByClassName("transitionStyles-" + this.transitionStyleId)[0];
        if (!styleTag) {
            const style = document.createElement("style");
            style.className = "transitionStyles-" + this.transitionStyleId;
            style.innerHTML = styleText;
            document.head.appendChild(style);
        } else {
            styleTag.innerHTML = styleText;
        }
    }
}
